import axios from 'axios'
import { getConfig } from '../lib/config'

export const getHistoricalImagery = async () => {
  const serviceUrl = getConfig('WAYBACK_IMAGERY_CONFIG_URL')
  return axios({
    method: 'GET',
    url: serviceUrl
  })
    .then(response => {
      return {
        success: true,
        data: response.data
      }
    })
    .catch(error => {
      return { success: false, data: error }
    })
}
